import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '../Buttons/ButtonBase';
import { FieldArray } from 'formik';
import  LawyerCertificationForm from './LawyerCertificationForm';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { storage } from '../../configs/environments/firebase/firebaseApp';
import { activeDeleteReset } from "../../store/actions/DeleteImageAction";
import { showLoading } from "../../store/actions/LoadingActions";
import "./addCertifications.scss";

const styles = () => ({
  expandButton: {
    display: 'flex',
    color: '#013957',
    cursor: 'pointer',
  },
  ButtonBase: {
    padding: 0,
    margin: 0,
    width: 144,
    minWidth: 'initial',
  },
  linkStyle: {
    width: 144,
    margin: '0 10px 0 0',
    '&:last-child': {
      margin: 0
    }
  },
});

const CertificationFormContainer = props => {

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    classes,
    setFieldValue,
    evento,
    helper,
    helperTrue,
    helperFalse,
    getValues,
    handleIsLimit,
    nElem,
    item,
    uid,
    deleteImg,
    resetForm,
    activeDeleteReset,
    showLoading,
    certificationsLawyer,
  } = props; 
    
  const isObjectFull = (array) => {
    if (array) {
      const allValues = Object.values(array.slice(-1).pop())
      const evaluation = allValues.every(elem => {
        if (elem !== '') {
          return true
        }
        return false
      })
      return evaluation;
    }
  }

  const hasFile = (array) => {
    if (array) {
      const allValues = Object.values(array.slice(-1).pop())
      const isFiled = allValues.some(elem => {
        if (typeof elem === 'object') {
          return true
        }
        return false
      })
      return isFiled;
    }
  }
  
  const someIsFile = () => {
    let isFile = false
    const certFiles = hasFile(values.certificationsLawyer)
    if (certFiles) {
      isFile = true
    }
    return isFile
  }

  const [cancelData, setCancelData] = useState(false);
  const [erase, setErase] = useState(false)

  const handleCancel = event => {
    event.preventDefault();
    resetForm()
    if (!values.flagEdit) {
      setErase(true)
      setCancelData(true)
    }
    evento();
    if (values.flagEdit) {
      activeDeleteReset()
      setErase(true)
    }
  };

  useEffect(() => {
    if (handleIsLimit) {
      handleIsLimit(values.certificationsLawyer)
    }
    getValues(isObjectFull(values.certificationsLawyer))
    if (helper && isObjectFull(values.certificationsLawyer)) {
      values.certificationsLawyer.push({
        name: '',
        place: '',
        year: '',
        myImageCert: '',
      })
    }
    helperFalse()
  }, [
    getValues,
    handleIsLimit,
    helper,
    helperFalse,
    helperTrue,
    values.certificationsLawyer
  ])

  const addArrayToFirebaseStorage = async (array, routeName, subRouteName) => {
    return new Promise(async (resolve, reject) => {
      if (array && array.length !== 0) {
        const data = array.map(async (elem, index) => {
          let file
          let getUrl = ''
          let isFile = false
          if (elem.myImageCert) {
            file = elem.myImageCert
          }
          if (typeof file === 'object') {
            isFile = true
          }
          if (file && isFile) {          
            try {
              let sPhoto = `CA_${Math.floor(Math.random() * 10)}_${nElem ? nElem : item}`;
              const firebasePromise = storage
                .ref(`profileImage/${uid}/${routeName}/${subRouteName}/${sPhoto}`)
                .put(file)
              return firebasePromise.then(async () => {
                try {
                  getUrl = await storage
                    .ref(`profileImage/${uid}/${routeName}/`)
                    .child(`${subRouteName}/${sPhoto}`).getDownloadURL()
                    values.certificationsLawyer[index]['myImageCert'] = getUrl
                    return getUrl
                } catch (error) {
                  console.log(error);
                }
              })
            } catch (error) {
              console.log('error catch array', error); 
            }
          }
        })
        try {
          const res = await Promise.all(data)
          resolve(res)
        } catch (error) {
          return reject(error)
        }
      } else {
        return resolve()
      }
    })
  }

  const deleteArrayFromStorage = async () => {
    return new Promise(async (resolve, reject) => {
      let array
      if (certificationsLawyer && certificationsLawyer.length !== 0) {
          array = certificationsLawyer.filter((elem, index) => {
          if (
            deleteImg.certifications.length !== 0 &&
            deleteImg.certifications[index] === true
          ) {
            return index
          }
        })
      }
      const data = array.map(async (elem) => {
        let pathImg = ''
        if (elem.myImageCert && elem.myImageCert.includes('firebase')) {
          pathImg = elem.myImageCert
        }
        if (pathImg) {
          try {
            const deletePromise = await storage
              .refFromURL(pathImg)
              .delete()
            return deletePromise
          } catch (error) {
            return reject()
          }
        }
      })
      try {
        const res = await Promise.all(data)
        resolve(res)
      } catch (error) {
        return reject(error)
      }
    });
  };
  
  const onSubmit =  async (event) => {
    event.preventDefault()
    showLoading()
    const isFile = someIsFile()
    try {
      if (values.flagEdit) {
        const deleteCert = await deleteArrayFromStorage()
        await Promise.all([deleteCert])
      }

      if (isFile) {
        const certPromise = await addArrayToFirebaseStorage(values.certificationsLawyer, 'certificationsLawyer', 'certImage');
        await Promise.all([certPromise])

        setCancelData(true)
        activeDeleteReset()
        return handleSubmit()
      } else {
        activeDeleteReset()
        handleSubmit()
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      <form>
        <FieldArray
          name='certificationsLawyer'
          render={certificationsHelper => {
            return (
              <>
                {values.certificationsLawyer && values.certificationsLawyer.map((certification, index) => (
                    <LawyerCertificationForm
                        index={index}
                        key={index}
                        certification={certification}
                        certificationsHelper={certificationsHelper}
                        errors={errors}
                        touched={touched}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        handleCancel={handleCancel}
                        setFieldValue={setFieldValue}
                        flagEdit={values.flagEdit}
                        erase={erase}
                        setErase={setErase}
                        cancelData={cancelData}
                        setCancelData={setCancelData}
                        nElem={nElem}
                    />
                    ))
                }
              </>
            )}
          }
        />

        <div className="addCertifications_horizontal-layoutCertification" style={{ marginTop: 15 }}>
          <div style={{ display: 'flex' }}>
            <ButtonBase
              type="submit"
              onClick={onSubmit}
              variant="primary"
              linkStyle={classes.linkStyle}
              className={classes.ButtonBase }
              style={{ marginRight: 16}}
            >
           Guardar
            </ButtonBase>

            <ButtonBase
              type="submit"
              onClick={handleCancel}
              variant="primarySolidOutlined"
              linkStyle={classes.linkStyle}
              className={classes.ButtonBase}
            >
              Cancelar
            </ButtonBase>
          </div>
        </div>
      </form>
    </>
  )
};

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  certificationsLawyer: state.authClient.certificationsLawyer,
  deleteImg: state.DeleteImageReducer.deleteImg
})

const mapDispatchToProps = dispatch => ({
  showLoading: () => dispatch(showLoading()),
  activeDeleteReset: () =>
    dispatch(activeDeleteReset())
});

const CertificationFormContainerCompose = compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(CertificationFormContainer)

export default CertificationFormContainerCompose;
